import { createFileRoute } from '@tanstack/react-router'
import { OrderEditor } from '@/routes/sales/orders/-OrderEditor'

export const Route = createFileRoute('/sales/orders/$id/')({
  component: OrderDetailPage,
})

function OrderDetailPage() {
  const { id } = Route.useParams()
  return <OrderEditor id={id} />
}
